import { ChevronDownIcon } from '@chakra-ui/icons';
import { Button, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { translate } from '../../../i18n';
import { Currency } from '../../../models/court-pricing/dto/court-pricing-rule.dto';

interface CurrencyPickerProps {
    selectedCurrency: Currency;
    onCurrencyChange: (currency: Currency) => void;
}
export function currencyEnumToSymbol(currency: Currency): string {
    switch (currency) {
        case Currency.USD:
            return '$';
        case Currency.EUR:
            return '€';
        default:
            return '';
    }
}

const LOCAL_STORAGE_KEY = 'lastSelectedCurrency';
export function getDefaultCurrency() {
    return localStorage.getItem(LOCAL_STORAGE_KEY) as Currency || Currency.EUR;
}

const CurrencyPicker: React.FC<CurrencyPickerProps> = ({ selectedCurrency, onCurrencyChange }) => {
    const handleChange = (value: string) => {
        const newCurrency = value as Currency;
        onCurrencyChange(newCurrency);
        localStorage.setItem(LOCAL_STORAGE_KEY, newCurrency);
    };

    return (
        <Popover>
            <PopoverTrigger>
                <Button h={8} w={12} rightIcon={<ChevronDownIcon />} variant={'outline'}>{currencyEnumToSymbol(selectedCurrency)}</Button>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverHeader>{translate('coupon.select_currency')}</PopoverHeader>
                <PopoverBody>
                    <RadioGroup onChange={handleChange} value={selectedCurrency}>
                        <Stack>
                            <Radio value={Currency.USD}>$</Radio>
                            <Radio value={Currency.EUR}>€</Radio>
                            {/* Add more currencies as needed */}
                        </Stack>
                    </RadioGroup>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
};

export default CurrencyPicker;